import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();

    if (Object.keys(newErrors).length === 0) {
      // Form is valid - submit to FormSubmit
      setIsLoading(true);
      const form = e.target;
      const formSubmitData = new FormData(form);

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: formSubmitData,
          headers: {
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          setIsLoading(false);
          setSubmitted(true);

          // Reset form after 5 seconds
          setTimeout(() => {
            setFormData({
              name: '',
              email: '',
              subject: '',
              message: ''
            });
            setSubmitted(false);
          }, 5000);
        } else {
          setIsLoading(false);
          alert('There was an error submitting the form. Please try again.');
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Form submission error:', error);
        alert('There was an error submitting the form. Please try again.');
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-card">
        <Link to="/" className="back-link">← Back to Home</Link>
        <img
          src="/logo/lumisoro_icon_purple.svg"
          alt="Lumisoro Logo"
          className="contact-logo"
        />
        <h1 className="contact-title">Get in Touch</h1>
        <p className="contact-subtitle">
          Have questions about Lumisoro? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
        </p>

        {submitted ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Thank you for contacting us!</h2>
            <p>We'll get back to you shortly.</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            action="https://formsubmit.co/support@lumisoro.com"
            method="POST"
            className="contact-form"
          >
            {/* Hidden fields for FormSubmit configuration */}
            <input type="hidden" name="_subject" value="New Lumisoro Contact Form Submission" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />

            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? 'error' : ''}
                placeholder="Your name"
              />
              {errors.name && <span className="error-text">{errors.name}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? 'error' : ''}
                placeholder="your.email@example.com"
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className={errors.subject ? 'error' : ''}
                placeholder="What is this about?"
              />
              {errors.subject && <span className="error-text">{errors.subject}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className={errors.message ? 'error' : ''}
                rows="5"
                placeholder="Your message..."
              ></textarea>
              {errors.message && <span className="error-text">{errors.message}</span>}
            </div>

            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Sending...
                </>
              ) : (
                'Send Message'
              )}
            </button>
          </form>
        )}

        <div className="privacy-link">
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
